import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FullscreenMessageComponent } from '@examdojo/core/fullscreen-message';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'dojo-error-page',
  template: `
    <y42-fullscreen-message
      [header]="'examdojo.error_page.header' | transloco"
      [description]="'examdojo.error_page.description' | transloco"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col h-full justify-center' },
  imports: [FullscreenMessageComponent, TranslocoPipe],
})
export class ErrorPageComponent {}
